<div class="code-block">
    <div class="code-block-header">
        <p class="px-1">{{ language | titlecase }}</p>
        <p class="copy-button px-2" (click)="copyCode()">
            <i *ngIf="!showCopied" class="bi bi-clipboard mr-1"></i>
            <i *ngIf="showCopied" class="bi bi-check2 mr-1"></i>
            <span class="exclude-me">{{ showCopied ? 'Copied' : 'Copy Code' }}</span>
        </p>
    </div>
    <div
        class="app-ace-editor m-0"
        [ngStyle]="{ height: codeBlockHeight }"
        #editor
    ></div>
</div>
